export default [{
  title: '物联网',
  icon: 'industry_icon_01'
},
{
  title: '生物产业',
  icon: 'industry_icon_02'
},
{
  title: '生物工程',
  icon: 'industry_icon_03'
},
{
  title: '生物医药',
  icon: 'industry_icon_04'
},
{
  title: '生物农业',
  icon: 'industry_icon_05'
},
{
  title: '现代科技农业',
  icon: 'industry_icon_06'
},
{
  title: '生命科学',
  icon: 'industry_icon_07'
},
{
  title: '航空航天',
  icon: 'industry_icon_08'
},
{
  title: '集成电路',
  icon: 'industry_icon_09'
},
{
  title: '节能环保',
  icon: 'industry_icon_10'
},
{
  title: '信息产业',
  icon: 'industry_icon_11'
},
{
  title: '通信网络',
  icon: 'industry_icon_12'
},
{
  title: '5G',
  icon: 'industry_icon_13'
},
{
  title: '三网融合',
  icon: 'industry_icon_14'
},
{
  title: '新一代信息技术',
  icon: 'industry_icon_15'
},
{
  title: '新能源',
  icon: 'industry_icon_16'
},
{
  title: '新能源汽车',
  icon: 'industry_icon_17'
},
{
  title: '电动汽车',
  icon: 'industry_icon_18'
},
{
  title: '新材料',
  icon: 'industry_icon_19'
},
{
  title: '高端制造',
  icon: 'industry_icon_20'
},
{
  title: '智能制造',
  icon: 'industry_icon_21'
},
{
  title: '大数据',
  icon: 'industry_icon_22'
},
{
  title: '互联网+',
  icon: 'industry_icon_23'
},
{
  title: '云计算',
  icon: 'industry_icon_24'
},
{
  title: '区块链',
  icon: 'industry_icon_25'
},
{
  title: '数据创意',
  icon: 'industry_icon_26'
},
{
  title: '智慧物业',
  icon: 'industry_icon_27'
},
{
  title: '智慧社区',
  icon: 'industry_icon_28'
},
{
  title: '智能家居',
  icon: 'industry_icon_29'
},
{
  title: '智慧城市',
  icon: 'industry_icon_30'
},
{
  title: '技术投资',
  icon: 'industry_icon_31'
},
{
  title: '绿色地产',
  icon: 'industry_icon_32'
},
{
  title: '科创投资',
  icon: 'industry_icon_33'
},
{
  title: 'AI智能',
  icon: 'industry_icon_34'
},
{
  title: '机器人',
  icon: 'industry_icon_35'
},
{
  title: '新型地产',
  icon: 'industry_icon_36'
},
{
  title: '养老地产',
  icon: 'industry_icon_37'
},
{
  title: '文旅地产',
  icon: 'industry_icon_38'
},
{
  title: '特色小镇',
  icon: 'industry_icon_39'
},
{
  title: '产业地产',
  icon: 'industry_icon_40'
},
{
  title: '休闲农业',
  icon: 'industry_icon_41'
},
{
  title: '养生地产',
  icon: 'industry_icon_42'
},
{
  title: '物流地产',
  icon: 'industry_icon_43'
},
{
  title: '长租公寓',
  icon: 'industry_icon_44'
},
{
  title: '联合办公',
  icon: 'industry_icon_45'
},
{
  title: '新型住宅',
  icon: 'industry_icon_46'
},
{
  title: '智慧商业地产',
  icon: 'industry_icon_47'
},
{
  title: '新型豪宅',
  icon: 'industry_icon_48'
}
]